import cookie from 'cookie';
import get from 'lodash.get';
import {trackUserPreferenceCCPA} from '../utils/compliance-policy';
import {CCPA_STATE_COOKIE_NAME} from '../constants';

export const setTargeting = ({gaiaId, targetingParams, cmptst, clearPrevTargeting = true}) => {
    window.meso = window.meso || {};
    window.meso.targeting = window.meso.targeting || [];

    // Accept gaiaId as string OR empty string that signals of missed value
    if (!(gaiaId || gaiaId === '')) {
        return;
    }
    if (clearPrevTargeting) {
        window.meso.targeting.push({type: 'clear'});
    }

    const dateInterpreter = (date) => date === '-1' ? false : date;
    const numberInterpreter = (val) => val === '0' ? false : parseInt(val, 10);
    const targetingValMapping = [
        {vrboKey: 'adultsCount', mesoKey: 'adults', interpreter: numberInterpreter},
        {vrboKey: 'childrenCount', mesoKey: 'kids', interpreter: numberInterpreter},
        {vrboKey: 'arrival', mesoKey: 'dateStart', interpreter: dateInterpreter},
        {vrboKey: 'departure', mesoKey: 'dateEnd', interpreter: dateInterpreter},
    ];

    const targeting = targetingValMapping
        .reduce((acc, mapping) => {
            const {vrboKey, interpreter} = mapping;
            const targetingValue = get(targetingParams, `params.${vrboKey}`);
            const val = interpreter ? interpreter(targetingValue) : targetingValue;
            if (!val) {
                return acc;
            }
            const {mesoKey} = mapping;
            return {...acc, [mesoKey]: val};
        }, gaiaId ? {dest: gaiaId, locResolver: 'gaia'} : {});

    if (cmptst) {
        targeting.cmptst = cmptst;
    }
    window.meso.targeting.push({
        type: 'update',
        targeting
    });
};

export const onAdsContextInit = ({brandId, locale, havId}) => {
    window.meso = window.meso || {};
    window.meso.logging = window.meso.logging || [];
    window.meso.targeting = window.meso.targeting || [];
    window.meso.initialize = window.meso.initialize || [];
    window.meso.breakpoints = window.meso.breakpoints || [];
    window.cookieconsent = window.cookieconsent || [];
    window.meso.experiments = window.meso.experiments || [];

    const cookies = cookie.parse(document.cookie);
    const canSell = !(cookies[CCPA_STATE_COOKIE_NAME] === 'true');

    const pagetype = get(window, 'analyticsdatalayer.pagetype');
    const isLoggedIn = get(window, 'analyticsdatalayer.publicuuid', '-1') !== '-1';

    const pageId = `Vrbo.${pagetype}`;

    if (isLoggedIn && !canSell) {
        trackUserPreferenceCCPA();
    }

    document.cookie = cookie.serialize('DUAID', havId);

    window.meso.breakpoints.push({ type: 'platform', platform: 'vrbo' });

    window.cookieconsent.push((cookieAccess) => {
        const consents = cookieAccess && cookieAccess.getConsents();
        const canTrack = consents && consents.functional === true;
        window.meso.initialize.push({
            pageId,
            type: 'target',
            siteId: brandId,
            variant: 'default',
            locale: locale && locale.replace('-', '_'),
            canTrack,
            canSell,
            brand: 'vrbo'
        });
    });

    window.meso.experiments.push({
        type: 'update',
        experiments: {
            MeSo_Lazy_Loading_BEXG_NA: 1,
        }
    });
};
